import gql from 'graphql-tag'

export const Q_GET_NOTICE_TYPES = gql`
  query GetNoticeTypes {
    noticeTypes {
      id
      name
      level
      expirationMonths
      description
      template
      createdAt
      updatedAt
    }
  }
`

export const M_CREATE_NOTICE_TYPE = gql`
  mutation CreateNoticeType(
    $name: String!
    $level: Int!
    $expirationMonths: Int!
    $description: String
    $template: String
  ) {
    createNoticeType(
      name: $name
      level: $level
      expirationMonths: $expirationMonths
      description: $description
      template: $template
    ) {
      id
      name
      level
      expirationMonths
      description 
      template
    }
  }
`

export const M_UPDATE_NOTICE_TYPE = gql`
  mutation UpdateNoticeType(
    $id: Int!
    $name: String
    $level: Int
    $expirationMonths: Int
    $description: String
    $template: String
  ) {
    updateNoticeType(
      id: $id
      name: $name
      level: $level
      expirationMonths: $expirationMonths
      description: $description
      template: $template
    ) {
      id
      name
      level
      expirationMonths
      description
      template
    }
  }
`

export const M_DELETE_NOTICE_TYPE = gql`
  mutation DeleteNoticeType($where: NoticeTypeWhereInput!) {
    deleteNoticeType(where: $where)
  }
`